import { BuildClass, fsmData } from '../../../universal';
import { React, _ } from '../../lib';
import { useStateSync } from './meta-types';
import { stubSelect } from './stubs';
const DropdownComponent = (props, ref) => {
    const refElement = React.useRef(stubSelect);
    const [value, setValue] = React.useState(props.value);
    useStateSync({
        stateVal: value,
        propVal: props.value,
        setState: setValue,
        setProp: props.onUpdate,
    });
    const getValue = () => {
        if (!props.multiple) {
            return refElement.current.value;
        }
        const opts = refElement.current?.querySelectorAll('option');
        return fsmData(Array.from(opts), {
            filter: el => el.selected,
            map: el => el.value ?? '1',
        });
    };
    const onChange = React.useCallback(() => {
        setValue(getValue());
    }, []);
    React.useImperativeHandle(ref, () => refElement.current);
    return (React.createElement("select", { ref: refElement, className: BuildClass({
            'ui5 ui5-select': true,
            [props.className ?? '']: true,
        }), value: value, onChange: onChange, ..._.omit(props, ['value', 'onUpdate']) }));
};
export const Dropdown = React.forwardRef(DropdownComponent);
//# sourceMappingURL=dropdown.js.map